import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ApiRequest = async (method, endpoint, payload = {}) => {
  const token = localStorage.getItem("accessTokenawl");
  const headers = {
    headers: {
      "x-access-token": token,
    },
  };
  try {
    let response = null;
    switch (method) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, headers);
        break;

      case "GET":
        response = await axios.get(BaseUrl + endpoint, headers);
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      case "DELETE":
        response = await axios.delete(BaseUrl + endpoint, { ...headers, data: payload });
        break;

      default:
        throw new Error(`Invalid method: ${method}`);
    }
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    if ((status === 401 || status === 403) && window.location.pathname !== "/login") {
      localStorage.removeItem("accessTokenawl");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      window.location.href = "/login";
    }
    throw error;
  }
};

export default ApiRequest;
